import React from 'react'

const Accueil = () => {
return(
    <div className="mx-8">
        <h1 className="py-4 text-xl font-bold leading-tight tracking-tight text-gray-900">Bienvenue !</h1>
        <div className="py-16">
        </div>
    </div>
    )
}

export default Accueil
